import React, { useEffect, useState, useContext } from "react"

import { Link, navigate } from "gatsby"
import { Col, Container, Image, Row } from "react-bootstrap"

import { GlobalAuthContext } from "../../../context/authContext"

import { GET_CONFIG_DATA } from "../../shared-actions/get-config-data"

import "./hero.scss"
import InputBox from "../../../components/input/wdn-input-box"
import renderElement from "../../../utils/renderElement"
import getCountryData from "../../../utils/get-country-data"

const Hero = ({ article }) => {
  const [position, setPosition] = useState("")
  const [country, setCountry] = useState()
  const [config, setConfig] = useState([]) // eslint-disable-line no-unused-vars
  const [error, setError] = useState([]) // eslint-dsiable-line no-unused-vars

  const { state, dispatch } = useContext(GlobalAuthContext)

  useEffect(() => {
    if (!state.config) {
      GET_CONFIG_DATA(setConfig, dispatch)
    } else {
      setConfig(state.config)
      setCountry(state?.config?.current_country_id)
    }
  }, [state?.config]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = value => {
    setCountry(value)
  }

  const handlePositionChange = value => {
    setPosition(value.target.value)
  }

  const getMinSalary = () => {
    const value = getCountryData(config.country, country)
    return value.minSalary
  }

  const onFocus = () => {
    setError({})
  }

  const handleFindClick = e => {
    e.preventDefault()
    let url = ""
    if (country === 0) {
      setError({ country: "required country" })
    } else if (!position) {
      setError({ position: "required position" })
    } else {
      if (state.config) {
        // const maxExp = getMaxExperience()
        const minSal = getMinSalary()
        // eslint-disable-next-line no-useless-concat
        url =
          "?country=" +
          country +
          "&position=" +
          position +
          "&minExperience=0" +
          "&maxExperience=" +
          5 +
          "&minSalary=" +
          minSal
        navigate("/search-candidates" + url)
      }
    }
  }
  return (
    <>
      <Container>
        <Row className="align-items-center">
          {article?.image?.url && (
            <Col xs="12" lg={{ span: 5, order: "last" }}>
              <Image
                className="hero-image"
                src={article?.image?.url}
                alt={article?.image?.alt}
              />
            </Col>
          )}

          <Col xs="12" lg={{ span: 7, order: "first" }}>
            <div>
              {article?.title && (
                <h1
                  dangerouslySetInnerHTML={renderElement(article?.title)}
                ></h1>
              )}
            </div>
            <form onSubmit={handleFindClick}>
              <div className="hero__input-box">
                <Row>
                  {article?.include_search_bar === "1" && (
                    <>
                      {/* <Col xs="12" sm="4" md="4" className="p-0">
                        <InputBox
                          onFocus={onFocus}
                          type="select"
                          options={state?.config?.country}
                          key_value="name"
                          optionHeader="Country"
                          value={country}
                          width="100%"
                          styles={error.country ? "error w-100" : "w-100"}
                          disabled
                          onChange={handleChange}
                        />
                      </Col> */}
                      <Col xs="12" sm="6" md="6" className="p-0">
                        <InputBox
                          onChange={handlePositionChange}
                          onFocus={onFocus}
                          value={position}
                          styles={error.position ? "error" : "allow-focus"}
                          placeholder="Accountant"
                        />
                      </Col>
                      <Col xs="12" sm="4" md="4" className="p-0">
                        <button
                          className="btn btn-custom primary"
                          onClick={handleFindClick}
                          dangerouslySetInnerHTML={renderElement(
                            article?.cta_text
                          )}
                        ></button>
                      </Col>
                      <Col xs="12" className="p-0">
                        <p className="jobs-cta">
                          Looking for <Link to="/jobs">Jobs?</Link>
                        </p>
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Hero
